export default "__VITE_ASSET__Dur7YvCx__"